var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VIcon',{attrs:{"small":_vm.$vuetify.breakpoint.xsOnly}},[_vm._v(" "+_vm._s(_vm.closeIcon)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }